'use client';

import type { MobonPaymentSuccessParams, MobonSNSAuthParams } from '@module/global';

export const spaAdvert = (type: string, data = {}) => {
  if (typeof (<any>window).spaAdvert !== 'undefined') {
    (<any>window).spaAdvert(type, data);
  }
};

export const MOBON_PAY_CODE_MAP: Record<string, MobonPaymentSuccessParams['payCode']> = {
  kakaopay: '10001',
  naverpay: '10002',
  payco: '10005',
  default: '19000',
} as const;

export const MOBON_SNS_CODE_MAP: Record<string, MobonSNSAuthParams['snsCode']> = {
  KAKAO: '00001',
  NAVER: '00002',
  FACEBOOK: '00003',
  INSTAGRAM: '00004',
  default: '09000',
} as const;

export const getMobonPayCode = (methodCode: string | null): MobonPaymentSuccessParams['payCode'] => {
  return MOBON_PAY_CODE_MAP[methodCode ?? 'default'];
};

export const getMobonSnsCode = (social: string): MobonSNSAuthParams['snsCode'] => {
  return MOBON_SNS_CODE_MAP[social ?? 'default'];
};
